"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailLabel = exports.IconWrapper = exports.AddButtonWrapper = exports.SimpleButton = exports.OverlayClose = exports.LoadingContainer = exports.Image = exports.ThumbnailContainer = exports.ThumbnailOverlay = exports.thumbnailOverlay = void 0;
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Theme_1 = require("../../styles/Theme");
exports.thumbnailOverlay = 'overlay-class';
// Commented out temporarily because this is breaking certain downstream builds for unknown reasons
// export const fadeIn = keyframes`
//   from {
//     opacity: 0;
//   }
//   to {
//     opacity: 1;
//   }
// `;
// export const animation = css`
//   ${fadeIn} 0.3s ease-in-out
// `;
// Cast is becauset the `styled` method appears to not properly support the animation property
exports.ThumbnailOverlay = (0, Theme_1.driftStyled)('div')({
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    boxSize: 'content-box',
    zIndex: 5,
});
exports.ThumbnailContainer = (0, Theme_1.driftStyled)(material_1.Box)(({ size, border, theme }) => ({
    backgroundColor: 'transparent',
    borderRadius: `2px`,
    border: border ? `2px solid ${theme.palette.primary.main}` : 'none',
    height: `${size}px`,
    width: `${size}px`,
    boxSizing: 'border-box',
    padding: '0px',
    margin: '0px',
    overflow: 'hidden',
    position: 'relative',
    [`&:hover .${exports.thumbnailOverlay}`]: {
        display: 'flex',
    },
}));
// Cast is becauset the `styled` method appears to not properly support the animation property
exports.Image = (0, Theme_1.driftStyled)('img')({
    width: '100%',
    height: '100%',
    zIndex: 1,
    // animation: css`
    //   ${fadeIn} 0.3s ease-in-out
    // `,
});
exports.LoadingContainer = (0, Theme_1.driftStyled)('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    background: theme.palette.gray['300'],
}));
exports.OverlayClose = (0, Theme_1.driftStyled)(Close_1.default)({
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '0',
    margin: '4px',
    cursor: 'pointer',
    color: 'white',
    width: '16px',
    height: '16px',
    boxSizing: 'content-box',
    zIndex: 2,
});
exports.SimpleButton = (0, Theme_1.driftStyled)('button')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    width: '100%',
    height: '100%',
    padding: 0,
    margin: 0,
    border: 'none',
    outline: 'none',
});
exports.AddButtonWrapper = (0, Theme_1.driftStyled)('button')({
    width: '100%',
    height: '100%',
    display: 'flex',
    background: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1.5px dashed #EEEEEE',
    borderRadius: '2px',
});
exports.IconWrapper = (0, Theme_1.driftStyled)('span')({
    display: 'flex',
    padding: 0,
    margin: 0,
    border: 'none',
    outline: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
});
exports.ThumbnailLabel = (0, Theme_1.driftStyled)(material_1.Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px',
    textAlign: 'center',
    paddingTop: '4px',
}));
//# sourceMappingURL=ThumbnailStyledComponents.js.map